// const baseUrl = 'http://103.203.137.244/v1'
const baseUrl = 'https://hry178.haryanadwlr.in/v1'

export default baseUrl
